import type { ReactNode } from 'react';
import { AlertCircle, Clock, ShieldAlert, ShieldCheck } from 'lucide-react';

import { Tooltip } from '@/components/ui/tooltip';

import { KnownWarrantyCoverageStatus } from '../entities/warranty-coverage-status';

type WarrantyCoverageStatusIconProps = {
  // INFO: for the moment there is only icon for known statuses
  status: KnownWarrantyCoverageStatus;
};

const iconFromStatus: Record<KnownWarrantyCoverageStatus, ReactNode> = {
  [KnownWarrantyCoverageStatus.NO_DATA]: <AlertCircle className="size-4" />,
  [KnownWarrantyCoverageStatus.VALID]: <ShieldCheck className="size-4" />,
  [KnownWarrantyCoverageStatus.EXPIRED]: <Clock className="size-4" />,
  [KnownWarrantyCoverageStatus.CASE_OPEN]: <ShieldAlert className="size-4" />,
};

export const tooltipFromStatus: Record<KnownWarrantyCoverageStatus, string> = {
  [KnownWarrantyCoverageStatus.NO_DATA]: 'No Data',
  [KnownWarrantyCoverageStatus.VALID]: 'Warranty Valid',
  [KnownWarrantyCoverageStatus.EXPIRED]: 'Warranty Expired',
  [KnownWarrantyCoverageStatus.CASE_OPEN]: 'Warranty Case Open',
};

export function WarrantyCoverageStatusIcon({
  status,
}: WarrantyCoverageStatusIconProps) {
  return (
    <Tooltip
      hide={status === KnownWarrantyCoverageStatus.NO_DATA}
      delay
      content={tooltipFromStatus[status]}
    >
      {iconFromStatus[status]}
    </Tooltip>
  );
}
